import React, { useState } from "react";
import logo from "../Assets/Logo/small.png";
import user from "../Assets/Icon/user.webp";
import lock from "../Assets/Icon/lock.webp";
import key from "../Assets/Icon/Vector.webp";
import { useNavigate } from "react-router-dom";
import { UserLoginSubmit } from "../Repository/Api";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../Store/auth/action";
import { errorMsg, successMsg } from "./Toastify";
import { NonEmptyValidation, PasswordValidation } from "../Store/validate";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [login, SetLogin] = useState([]);
  const [password, setPassword] = useState();

  const [loading, setLoading] = useState(false);
  const [registerValidation, setRegisterValidation] = useState({});

  const setRegisterValidationValue = (key, value) => {
    setRegisterValidation({ ...registerValidation, [key]: value });
  };

  const viewPassword = () => {
    setPassword(!password);
  };

  const setData = (e, key) => {
    let TempData = login;
    TempData[key] = e;
    SetLogin(TempData);
    if (registerValidation[key])
      setRegisterValidation({ ...registerValidation, [key]: false });
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    let validate = {};
    validate.user_name = NonEmptyValidation(login?.user_name);
    validate.password = PasswordValidation(login?.password);
    setRegisterValidation(validate);

    if (
      Object.values(validate).every((v) => v.status === true) &&
      userInput === captchaText
    ) {
      const Payload = {
        user_name: login.user_name,
        password: login.password,
      };

      const response = await UserLoginSubmit(Payload);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setLoading(false);
        dispatch(loginSuccess(response.data, response?.data?.access_token));
        if (response?.data?.first_time_password_changed === true) {
          navigate("/app/dashboard");
        } else {
          navigate("/ChangePassword");
        }
      } else {
        errorMsg(response.message);
        setLoading(false);
      }
    } else {
      setLoading(false);
      setIsValid(false);
    }
  };

  const generateRandomString = (length) => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let randomString = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      randomString += chars.charAt(randomIndex);
    }
    return randomString;
  };
  const [captchaText, setCaptchaText] = useState(generateRandomString(6));
  const [userInput, setUserInput] = useState("");
  const [isValid, setIsValid] = useState(true);

  const regenerateCaptcha = () => {
    setCaptchaText(generateRandomString(6));
    setUserInput("");
    setIsValid(true);
  };
  const handleInputChange = (event) => {
    setUserInput(event.target.value);
    setIsValid(true);
  };

  return (
    <>
      <section className="signin">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-md-6 col-sm-12 col-12 ms-auto mx-auto">
              <div className="signinlogospace">
                <div className="centertext">
                  <img className="signinlogo" src={logo} alt="NITTTR" />
                </div>
                <div className="mt-3">
                  <form onSubmit={(e) => handleSubmit(e)}>
                    <div className="inputspace">
                      <img className="icon" src={user} alt="User" />
                      <input
                        type="text"
                        className="input-field"
                        placeholder="EMPLOYEE ID / EMAIL ID"
                        defaultValue={login.user_name}
                        onChange={(e) => {
                          setData(e.target.value, "user_name");
                        }}
                        onBlur={(e) => {
                          setRegisterValidationValue(
                            "user_name",
                            NonEmptyValidation(e.target.value)
                          );
                        }}
                        onKeyUp={(e) => {
                          setData("user_name", e.target.value);
                        }}
                      />
                      <small className="validationmsg">
                        {registerValidation?.user_name?.message
                          ? `User Id / Email Id ${registerValidation?.user_name?.message}`
                          : ""}
                      </small>
                    </div>
                    <div className="inputspace">
                      <img className="icon" src={lock} alt="User" />
                      <input
                        type={password ? "text" : "password"}
                        className="input-field"
                        placeholder="PASSWORD"
                        defaultValue={login.password}
                        onChange={(e) => {
                          setData(e.target.value, "password");
                        }}
                        onBlur={(e) => {
                          setRegisterValidationValue(
                            "password",
                            PasswordValidation(e.target.value)
                          );
                        }}
                        onKeyUp={(e) => {
                          setData("password", e.target.value);
                        }}
                      />
                      <div className="psw-icon">
                        {password ? (
                          <span
                            className="material-symbols-rounded cursor align-middle"
                            onClick={() => viewPassword()}
                          >
                            visibility
                          </span>
                        ) : (
                          <span
                            className="material-symbols-rounded cursor align-middle"
                            onClick={() => viewPassword()}
                          >
                            visibility_off
                          </span>
                        )}
                      </div>
                      <small className="validationmsg">
                        {registerValidation?.password?.message
                          ? `Password ${registerValidation?.password?.message}`
                          : ""}
                      </small>
                    </div>
                    <div className="inputspace">
                      <div className="row">
                        <div className="col-lg-8 col-md-8 col-sm-8 col-8">
                          <div className="inputimg">
                            <img className="icon" src={key} alt="User" />
                            <input
                              type="text"
                              className="input-field"
                              placeholder="SECURITY TEXT"
                              value={userInput}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-4 p-0">
                          <div className="captchabox">
                            <div className="row">
                              <div className="col-lg-8 col-md-8 col-sm-8 col-8 p-0">
                                <span className="captchasize unselectable">
                                  {captchaText}
                                </span>
                              </div>
                              <div className="col-lg-3 col-md-3 col-sm-3 col-2">
                                <span
                                  className="material-symbols-outlined captchbutton"
                                  onClick={regenerateCaptcha}
                                >
                                  cached
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {!isValid && (
                        <p className="validationmsg">
                          Invalid input. Please try again.
                        </p>
                      )}
                    </div>
                    <div className="inputspace mb-3">
                      <button className="loginbtn">
                        {loading ? (
                          <i className="fa fa-circle-o-notch fa-spin"></i>
                        ) : (
                          ""
                        )}
                        LOGIN
                      </button>
                    </div>
                    <div className="counticonflex">
                      <p
                        className="cursor"
                        onClick={() => {
                          navigate("/");
                        }}
                      >
                        <small>Back To Home</small>
                      </p>
                      <p
                        className="cursor"
                        onClick={() => {
                          navigate("/ForgetPassword");
                        }}
                      >
                        <small>Forgot password ?</small>
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;
